export function SuccessIcon(props: any) {
    return (
        <svg
            width={28}
            height={28}
            viewBox='0 0 28 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M17.627 9.72l-5.72 5.734-2.2-2.2a1.333 1.333 0 10-1.88 1.88l3.133 3.146a1.332 1.332 0 00.947.387c.35-.002.685-.14.933-.387l6.667-6.666a1.336 1.336 0 000-1.894 1.334 1.334 0 00-1.88 0zM14 .667a13.333 13.333 0 100 26.667A13.333 13.333 0 0014 .667zm0 24a10.666 10.666 0 110-21.333 10.666 10.666 0 010 21.333z'
                fill='#6FCF97'
            />
        </svg>
    )
}

export function CloseIcon(props: any) {
    return (
        <svg
            width={16}
            height={16}
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M8.94 8l4.2-4.193a.67.67 0 10-.947-.947L8 7.06l-4.193-4.2a.67.67 0 00-.947.947L7.06 8l-4.2 4.194a.666.666 0 000 .946.668.668 0 00.947 0L8 8.94l4.193 4.2a.667.667 0 001.093-.217.668.668 0 00-.146-.73L8.94 8z'
                fill='#828282'
            />
        </svg>
    )
}

export function ErrorIcon(props: any) {
    return (
        <svg
            width={28}
            height={28}
            viewBox='0 0 28 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M14 .666a13.333 13.333 0 100 26.667A13.333 13.333 0 0014 .666zm0 24A10.667 10.667 0 013.333 13.999a10.56 10.56 0 012.254-6.533l14.946 14.947A10.56 10.56 0 0114 24.666zm8.413-4.133L7.467 5.586A10.56 10.56 0 0114 3.333a10.666 10.666 0 0110.667 10.666 10.56 10.56 0 01-2.254 6.534z'
                fill='#EB5757'
            />
        </svg>
    )
}

export function WarningIcon(props: any) {
    return (
        <svg
            width={28}
            height={28}
            viewBox='0 0 28 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M14 12.666a1.333 1.333 0 00-1.333 1.333v5.334a1.333 1.333 0 102.666 0v-5.334A1.334 1.334 0 0014 12.666zm.507-5.227a1.333 1.333 0 00-1.014 0 1.334 1.334 0 00-.44.28c-.117.13-.212.279-.28.44a1.12 1.12 0 00-.106.507 1.333 1.333 0 00.386.947c.13.117.279.212.44.28a1.333 1.333 0 001.84-1.227 1.4 1.4 0 00-.386-.947 1.334 1.334 0 00-.44-.28zM14 .666a13.333 13.333 0 100 26.667A13.333 13.333 0 0014 .666zm0 24a10.667 10.667 0 110-21.334 10.667 10.667 0 010 21.334z'
                fill='#F2C94C'
            />
        </svg>
    )
}
